/**
 * QUEM PODE MEXER NAS REGRAS — T17.
 *
 * *"num painel onde um perfil com autorização administrativa consiga mexer"*.
 *
 * ── A AUTORIZAÇÃO NÃO É UM CAMPO DA CONTA, E ISSO NÃO É DETALHE ─────────────────────────────
 *
 * O `firestore.rules` deste produto já diz, no bloco de vínculos: *"o TIPO DE CONTA declarado em
 * `users/{uid}` NÃO serve de autorização aqui. O cliente escreve aquele campo, e quem escreve pode
 * mentir."*
 *
 * Vale em dobro para o painel das regras. Um `admin: true` no próprio documento deixaria qualquer
 * pessoa com conta reescrever a lista de palavras barradas de uma plataforma usada por crianças de
 * 6 anos — bastaria editar o próprio cadastro.
 *
 * Então a autorização é a EXISTÊNCIA de `administradores/{uid}`, uma coleção com `allow write: if
 * false`: ninguém a escreve pelo cliente, nem um administrador. Quem entra nela entra pelo console,
 * pela equipe — o mesmo caminho que ativar uma instituição já usa desde o T2.74.
 *
 * ── E ESTA FUNÇÃO NÃO É A TRAVA ─────────────────────────────────────────────────────────────
 *
 * Ela decide se o menu aparece. A trava é a regra do banco, que recusa a escrita de quem não está
 * na coleção. Esconder o botão sem a regra seria decoração; a regra sem esconder o botão daria uma
 * tela que falha ao salvar. As duas existem, e só uma delas é segurança.
 */
import Firebase, { auth } from "../api/firebase.class";
import { COLECAO_DOS_ADMINISTRADORES } from "./as-regras-no-painel";

/**
 * A pessoa logada pode editar as regras?
 *
 * `false` para quem não está logado, para quem não está na coleção, e **para qualquer erro de
 * leitura** — inclusive o `permission-denied` que a própria regra devolve para quem tenta ler o
 * documento de outra pessoa. Erro vira "não", nunca "sim": é a única direção segura quando a
 * resposta não chegou.
 */
export async function souAdministrador(): Promise<boolean> {
  const uid = auth?.currentUser?.uid;
  if (!uid) return false;
  try {
    const doc = await Firebase.getDocument(COLECAO_DOS_ADMINISTRADORES, uid);
    return !!doc;
  } catch {
    return false;
  }
}
